import React from 'react';
import { ExternalLink, Compass } from 'lucide-react';

export default function AutoCADScreen() {
  return (
    <div className="flex flex-col gap-6 w-full max-w-full pb-12 overflow-x-hidden">
      <div className="relative overflow-hidden w-full h-32 bg-white border border-slate-200 rounded-xl flex items-center justify-between">
        <div className="pl-8 z-20">
          <h1 className="font-serif font-medium text-3xl text-slate-900 tracking-wide">
            AutoCAD Web
          </h1>
          <p className="text-sm font-body text-slate-400 mt-2 font-medium">Access your cloud designs and DWG files securely</p>
        </div>
        <div className="w-[50%] h-full relative overflow-hidden flex-shrink-0">
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent z-10 w-48" />
          <img
            src="/kitchens/1.jpg"
            alt="AutoCAD Background"
            className="absolute top-0 right-0 w-full h-full object-cover object-center"
          />
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center">
        <div className="w-20 h-20 bg-slate-100 rounded-2xl flex items-center justify-center text-slate-700 shadow-sm border border-slate-200 mb-6">
          <Compass size={36} strokeWidth={1.5} />
        </div>
        <h2 className="text-2xl font-medium text-slate-800 font-sans mb-3">Launch Autodesk AutoCAD</h2>
        <p className="text-slate-500 font-body text-center max-w-md mb-8 leading-relaxed">
          For security and performance reasons, Autodesk requires AutoCAD Web to run in its own secure browser window. Click the button below to launch your AutoCAD environment.
        </p>
        <button
          onClick={() => window.open("https://web.autocad.com/login", "_blank")}
          className="flex items-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-xl hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl font-medium tracking-wide"
        >
          <span>Open AutoCAD Web</span>
          <ExternalLink size={18} />
        </button>
      </div>
    </div>
  );
}
